var _path, _path2, _mask, _rect, _mask2, _rect2, _mask3, _rect3, _mask4, _rect4, _mask5, _rect5, _mask6, _rect6, _mask7, _rect7, _mask8, _rect8, _mask9, _rect9, _mask10, _rect10, _mask11, _rect11, _path3, _mask12, _rect12, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgApartment = function SvgApartment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 50 38"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    d: "M21.5 5.377v32m24.277-15.5v15M26.5 9.377v28m13.418-15.625v15.125"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M48.5 23.517v13.86h-47v-32h20.117L26.5 9.046v4.076h9.93l3.475 3.261v7.134-1.834h5.852z"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "apartment_svg__a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.5,
    height: 3.5,
    x: 4.65,
    y: 8.95,
    rx: 0.37
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 3.5,
    height: 3.5,
    x: 4.65,
    y: 8.95,
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: 2,
    mask: "url(#apartment_svg__a)",
    rx: 0.37
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "apartment_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.5,
    height: 3.5,
    x: 9.61,
    y: 8.95,
    rx: 0.37
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 3.5,
    height: 3.5,
    x: 9.61,
    y: 8.95,
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: 2,
    mask: "url(#apartment_svg__b)",
    rx: 0.37
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "apartment_svg__c",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.5,
    height: 3.5,
    x: 14.58,
    y: 8.95,
    rx: 0.37
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 3.5,
    height: 3.5,
    x: 14.58,
    y: 8.95,
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: 2,
    mask: "url(#apartment_svg__c)",
    rx: 0.37
  })), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "apartment_svg__d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.5,
    height: 3.5,
    x: 4.65,
    y: 14.45,
    rx: 0.37
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 3.5,
    height: 3.5,
    x: 4.65,
    y: 14.45,
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: 2,
    mask: "url(#apartment_svg__d)",
    rx: 0.37
  })), _mask5 || (_mask5 = /*#__PURE__*/React.createElement("mask", {
    id: "apartment_svg__e",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.5,
    height: 3.5,
    x: 9.61,
    y: 14.45,
    rx: 0.37
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 3.5,
    height: 3.5,
    x: 9.61,
    y: 14.45,
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: 2,
    mask: "url(#apartment_svg__e)",
    rx: 0.37
  })), _mask6 || (_mask6 = /*#__PURE__*/React.createElement("mask", {
    id: "apartment_svg__f",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.5,
    height: 3.5,
    x: 14.58,
    y: 14.45,
    rx: 0.37
  }))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 3.5,
    height: 3.5,
    x: 14.58,
    y: 14.45,
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: 2,
    mask: "url(#apartment_svg__f)",
    rx: 0.37
  })), _mask7 || (_mask7 = /*#__PURE__*/React.createElement("mask", {
    id: "apartment_svg__g",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.5,
    height: 3.5,
    x: 4.65,
    y: 19.95,
    rx: 0.37
  }))), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 3.5,
    height: 3.5,
    x: 4.65,
    y: 19.95,
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: 2,
    mask: "url(#apartment_svg__g)",
    rx: 0.37
  })), _mask8 || (_mask8 = /*#__PURE__*/React.createElement("mask", {
    id: "apartment_svg__h",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.5,
    height: 3.5,
    x: 9.61,
    y: 19.95,
    rx: 0.37
  }))), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 3.5,
    height: 3.5,
    x: 9.61,
    y: 19.95,
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: 2,
    mask: "url(#apartment_svg__h)",
    rx: 0.37
  })), _mask9 || (_mask9 = /*#__PURE__*/React.createElement("mask", {
    id: "apartment_svg__i",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.5,
    height: 3.5,
    x: 14.58,
    y: 19.95,
    rx: 0.37
  }))), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 3.5,
    height: 3.5,
    x: 14.58,
    y: 19.95,
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: 2,
    mask: "url(#apartment_svg__i)",
    rx: 0.37
  })), _mask10 || (_mask10 = /*#__PURE__*/React.createElement("mask", {
    id: "apartment_svg__j",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.5,
    height: 3.5,
    x: 30.02,
    y: 15.95,
    rx: 0.37
  }))), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 3.5,
    height: 3.5,
    x: 30.02,
    y: 15.95,
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: 2,
    mask: "url(#apartment_svg__j)",
    rx: 0.37
  })), _mask11 || (_mask11 = /*#__PURE__*/React.createElement("mask", {
    id: "apartment_svg__k",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.5,
    height: 3.5,
    x: 30.02,
    y: 21.45,
    rx: 0.37
  }))), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 3.5,
    height: 3.5,
    x: 30.02,
    y: 21.45,
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: 2,
    mask: "url(#apartment_svg__k)",
    rx: 0.37
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M28.185 21.398c.202 0 .366.164.366.367v2.767a.366.366 0 0 1-.366.366H26v-3.5zm-2.134 2.5h1.5v-1.5h-1.5z",
    clipRule: "evenodd"
  })), _mask12 || (_mask12 = /*#__PURE__*/React.createElement("mask", {
    id: "apartment_svg__l",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.5,
    height: 3.5,
    x: 30.02,
    y: 26.95,
    rx: 0.37
  }))), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    width: 3.5,
    height: 3.5,
    x: 30.02,
    y: 26.95,
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: 2,
    mask: "url(#apartment_svg__l)",
    rx: 0.37
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M28.185 26.951c.202 0 .366.164.366.366v2.768a.366.366 0 0 1-.366.366H26v-3.5zm-2.134 2.5h1.5v-1.5h-1.5z",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M36.5 13.377v24"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M28.185 15.951c.202 0 .366.164.366.366v2.768a.366.366 0 0 1-.366.366H26v-3.5zm-2.134 2.5h1.5v-1.5h-1.5z",
    clipRule: "evenodd"
  })));
};
export default SvgApartment;